import React from 'react';

import { ThemeManager as UiThemeManager } from '@aspid/ui';

import { useThemeFromUser } from './hooks';

import type { ThemeManagerProperties } from './ThemeManager.types';

export const ThemeManager: React.FC<ThemeManagerProperties> = ({
  children,
  forcedThemeMode,
}) => (
  <UiThemeManager theme={useThemeFromUser(forcedThemeMode)}>
    {children}
  </UiThemeManager>
);
